import * as React from 'react'
import Navbar from '../setup/Navbar'
import { Autocomplete, Container, Grid2, TextField } from '@mui/material'
import HeadingText from '../../BuiltInComponent/HeadingTest'
import { useDispatch, useSelector } from 'react-redux'
import { getClosingReport } from '../../features/AccountsReports/closingReportSlice'
import { getAllUsers } from '../../features/auth/authSlice'
import ClosingReportPDF from './ClosingReportPDF'
import Loading from '../../BuiltInComponent/Loading'
import DateTimePircker from '../../BuiltInComponent/DateTimePicker'
import dayjs from 'dayjs'

export default function ClosingReport() {
    const dispatch = useDispatch()
    const { cd, isLoading } = useSelector(state => state.clsngRpt)
    const { user, allUsers } = useSelector(state => state.auth)
    const [selectedDate, setSelectedDate] = React.useState(dayjs())
    const [selectedUserID, setSelectedUserID] = React.useState(user?.userID || '')
    const isPrimaryUser = String(user?.userType || '').trim().toLowerCase() === 'primary'

    const userOptions = React.useMemo(() => {
        const users = (Array.isArray(allUsers) ? allUsers : []).filter(
            (item) => String(item?.userType || '').trim().toLowerCase() !== 'ordertaker'
        )
        if (isPrimaryUser) return users

        const loggedInUser = users.find((item) => Number(item.userID) === Number(user?.userID)) || user
        return loggedInUser ? [loggedInUser] : []
    }, [allUsers, isPrimaryUser, user])

    const selectedUser = userOptions.find(
        (item) => Number(item.userID) === Number(selectedUserID)
    ) || null

    React.useEffect(() => {
        if (!user?.userID) return
        const branchID = user.branchID || user.defaultBranchID || 1
        dispatch(getAllUsers({ cmpID: user.cmpID, branchID }))
        setSelectedUserID(user.userID)
    }, [dispatch, user?.branchID, user?.cmpID, user?.defaultBranchID, user?.userID])

    React.useEffect(() => {
        if (!user?.userID || !selectedUserID) return
        dispatch(getClosingReport({
            closingDate: selectedDate.format('YYYY-MM-DD'),
            userID: selectedUserID,
            loggedInUserID: user.userID
        }))
    }, [dispatch, selectedDate, selectedUserID, user?.userID])

    React.useEffect(() => {
        if (!isPrimaryUser && user?.userID && Number(selectedUserID) !== Number(user.userID)) {
            setSelectedUserID(user.userID)
        }
    }, [isPrimaryUser, selectedUserID, user?.userID])

    const reportUser = selectedUser ? { ...user, ...selectedUser } : user

    return (
        <>
            <Navbar />
            <Container>
                <HeadingText text="Closing Report" />
                <Grid2 container spacing={2} sx={{ mb: 2, justifyContent: 'center' }}>
                    <Grid2 size={{ xs: 12, md: 4 }}>
                        <Autocomplete
                            options={userOptions}
                            value={selectedUser}
                            disabled={!isPrimaryUser}
                            getOptionLabel={(option) => option?.dispName || option?.userName || `User #${option?.userID || ''}`}
                            isOptionEqualToValue={(option, value) => Number(option?.userID) === Number(value?.userID)}
                            onChange={(event, value) => {
                                if (isPrimaryUser) setSelectedUserID(value?.userID || '')
                            }}
                            renderInput={(params) => <TextField {...params} label="Select User" size="small" />}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 3 }}>
                        <DateTimePircker
                            label="Pick a date"
                            value={selectedDate}
                            onChange={(newDate) => {
                                if (newDate?.isValid()) setSelectedDate(newDate)
                            }}
                        />
                    </Grid2>
                </Grid2>

                <Grid2 container justifyContent="center">
                    <Grid2 size={{ xs: 12, md: 6 }}>
                        {isLoading ? (
                            <Loading loadingText="Closing Data" />
                        ) : cd && cd.length > 0 ? (
                            <ClosingReportPDF closingData={cd} user={reportUser} />
                        ) : (
                            <div style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'center' }}>
                                No Closing Data Found
                            </div>
                        )}
                    </Grid2>
                </Grid2>
            </Container>
        </>
    )
}
